export interface MenuGroupModel {
  id: number
  name: string
}

export default class MenuGroup {
  private constructor (
    readonly id: number,
    readonly name: string
  ) {

  }

  public static createFromModel (data: Partial<MenuGroupModel>): MenuGroup {
    return new MenuGroup(
      data.id!,
      data.name!
    );
  }
}